import { render, staticRenderFns } from "./custom-checkbox.vue?vue&type=template&id=de440ace&scoped=true&"
import script from "./custom-checkbox.vue?vue&type=script&lang=ts&"
export * from "./custom-checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de440ace",
  null
  
)

export default component.exports